/* eslint-disable max-len */
import React from 'react';

var IconFain = function IconFain() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "11",
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.291992L11 5.50033L6 10.7087V6.54199H0V4.45866H6V0.291992Z",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0.291992H20V2.37533H11V0.291992Z",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.62533H20V10.7087H11V8.62533Z",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4.45866H14V6.54199H20V4.45866Z",
    fill: "#444749"
  }));
};

export default IconFain;